
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class RolService {

    static getAllRoles() {
  
        return axios.get(`${BaseUrl}Rol`);
    }
}


// WEBPACK FOOTER //
// ./src/Services/rolService/rolService.js